// extracted by mini-css-extract-plugin
module.exports = {"tab":"style_tab__3wKYD","item":"style_item__hzbh5"};